export default __webpack_public_path__ + "static/media/logomwifi.0d87aed9.png";